export enum LandingLanguage {
  en = "en",
  ru = "ru",
  es = "es",
  ptBr = "pt-br",
  uk = "uk",
}

export const landingLanguages = Object.values(
  LandingLanguage,
) as LandingLanguage[];

export const formatLandingLanguage = (lang: LandingLanguage): string => {
  switch (lang) {
    case LandingLanguage.en:
      return "English";
    case LandingLanguage.ru:
      return "Русский";
    case LandingLanguage.es:
      return "Español";
    case LandingLanguage.ptBr:
      return "Português";
    case LandingLanguage.uk:
      return "Українська";
    default:
      return lang satisfies never;
  }
};
